var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 7.74992C14.1665 8.05934 14.0436 8.35608 13.8248 8.57488C13.606 8.79367 13.3093 8.91659 12.9998 8.91659C12.6904 8.91659 12.3937 8.79367 12.1749 8.57488C11.9561 8.35608 11.8332 8.05934 11.8332 7.74992C11.8332 7.4405 11.9561 7.14375 12.1749 6.92496C12.3937 6.70617 12.6904 6.58325 12.9998 6.58325C13.3093 6.58325 13.606 6.70617 13.8248 6.92496C14.0436 7.14375 14.1665 7.4405 14.1665 7.74992ZM10.6665 12.1249C10.6665 11.8929 10.7587 11.6703 10.9228 11.5062C11.0869 11.3421 11.3094 11.2499 11.5415 11.2499H13.2915C13.5236 11.2499 13.7461 11.3421 13.9102 11.5062C14.0743 11.6703 14.1665 11.8929 14.1665 12.1249V17.0833H15.0415C15.2736 17.0833 15.4961 17.1754 15.6602 17.3395C15.8243 17.5036 15.9165 17.7262 15.9165 17.9583C15.9165 18.1903 15.8243 18.4129 15.6602 18.577C15.4961 18.7411 15.2736 18.8333 15.0415 18.8333H11.5415C11.3094 18.8333 11.0869 18.7411 10.9228 18.577C10.7587 18.4129 10.6665 18.1903 10.6665 17.9583C10.6665 17.7262 10.7587 17.5036 10.9228 17.3395C11.0869 17.1754 11.3094 17.0833 11.5415 17.0833H12.4165V12.9999H11.5415C11.3094 12.9999 11.0869 12.9077 10.9228 12.7436C10.7587 12.5795 10.6665 12.357 10.6665 12.1249Z",
    fill: "url(#paint0_linear_7338_87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 0.166626C5.91234 0.166626 0.166504 5.91246 0.166504 13C0.166504 20.0875 5.91234 25.8333 12.9998 25.8333C20.0873 25.8333 25.8332 20.0875 25.8332 13C25.8332 5.91246 20.0873 0.166626 12.9998 0.166626ZM1.9165 13C1.9165 10.0605 3.08421 7.24139 5.16274 5.16286C7.24126 3.08433 10.0604 1.91663 12.9998 1.91663C15.9393 1.91663 18.7584 3.08433 20.8369 5.16286C22.9155 7.24139 24.0832 10.0605 24.0832 13C24.0832 15.9394 22.9155 18.7585 20.8369 20.8371C18.7584 22.9156 15.9393 24.0833 12.9998 24.0833C10.0604 24.0833 7.24126 22.9156 5.16274 20.8371C3.08421 18.7585 1.9165 15.9394 1.9165 13Z",
    fill: "url(#paint1_linear_7338_87)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7338_87",
    x1: 10.8195,
    y1: 6.98442,
    x2: 10.8195,
    y2: 18.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7338_87",
    x1: 0.914417,
    y1: 1.00717,
    x2: 0.914417,
    y2: 25.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.a030426124bd184fdacfa4af15843294.svg";
export { ForwardRef as ReactComponent };